import { useEffect, useState, useMemo, useRef } from 'react';
import { debounce } from 'lodash-es';
import { queryBrandList, queryCompanyList } from '../apis';

const queryApis = {
  queryBrandList,
  queryCompanyList,
};

export interface OptionsArgs {
  queryApi: keyof typeof queryApis;
  keywordsKey: 'brand' | 'company';
  queryParams: any;
  dependencies: string[];
}

export const useOptions = ({ queryApi, keywordsKey, queryParams, dependencies }: OptionsArgs) => {
  // 记录是否在请求中
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState<Array<{ label: string; value: string }>>([]);
  const fecthRef = useRef(0);

  const api = queryApis[queryApi];
  // 用户打开页面的时候，请求一次所有数据
  useEffect(() => {
    setFetching(true);
    api({ [keywordsKey]: '', ...queryParams }).then((data) => {
      setOptions((data || []).map((item: string) => ({ label: item, value: item })));
      setFetching(false);
    });
  }, [...dependencies]);
  // 用户搜索的时候再请求一次数据
  const onSearch = useMemo(() => {
    const loadOptions = (keywords: string) => {
      fecthRef.current += 1;
      const fetchId = fecthRef.current;
      setOptions([]);
      setFetching(true);
      api({ [keywordsKey]: keywords, ...queryParams }).then((data) => {
        if (fetchId !== fecthRef.current) {
          return;
        }
        setOptions((data || []).map((item: string) => ({ label: item, value: item })));
        setFetching(false);
      });
    };
    return debounce(loadOptions, 500);
  }, [...dependencies]);

  return {
    fetching,
    options,
    onSearch,
  };
};
